import React, { useState, useRef } from 'react';
import * as XLSX from 'xlsx';

function CampaignModel({ setShowCampaignModal }) {
    const [mobileNumbers, setMobileNumbers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const fileInputRef = useRef(null);

    const ITEMS_PER_PAGE = 10;

    const handleCSVImport = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = evt.target.result;
            const workbook = XLSX.read(data, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            const numbers = json.slice(1).map((row, index) => ({
                id: index + 1,
                number: row[0]?.toString().trim() || '',
            })).filter(row => row.number);

            setMobileNumbers(numbers);
            setCurrentPage(1); 
        };

        reader.readAsBinaryString(file);
    };

    const triggerFileInput = () => {
        fileInputRef.current?.click();
    };

    const totalPages = Math.ceil(mobileNumbers.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const visibleNumbers = mobileNumbers.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    return (
        <div className='modal-view-container'>
            <div
                className="p-20"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    width: '100%',
                    maxWidth: '550px',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                    padding: '24px',
                }}
            >
                {/* Header */}
                <div className='flex mb-10' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: 'black' }}>
                        Campaign
                    </div>
                    <button
                        onClick={() => setShowCampaignModal(false)}
                        style={{
                            fontSize: '24px',
                            color: '#666',
                            cursor: 'pointer',
                            background: 'none',
                            border: 'none',
                        }}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>

                {/* CSV Import */}
                <div className='mb-10'>
                    <button
                        onClick={triggerFileInput}
                        style={{
                            padding: '10px 18px',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontWeight: '500',
                            fontSize: '15px',
                            transition: 'background 0.2s',
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0069d9')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#007bff')}
                    >
                        Import CSV
                    </button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".csv, .xlsx, .xls"
                        onChange={handleCSVImport}
                        style={{ display: 'none' }}
                    />
                </div>

                {/* Table */}
                {mobileNumbers.length > 0 && (
                    <>
                        <div className='flex justify-content-between' style={{ borderRadius: '10px', overflow: 'hidden' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f1f1f1' }}>
                                        <th style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>S.No</th>
                                        <th style={{ padding: '10px', borderBottom: '1px solid #ddd', textAlign: 'left' }}>Mobile Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleNumbers.map((row, i) => (
                                        <tr key={row.id} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                            <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>{row.id}</td>
                                            <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>{row.number}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Controls */}
                        <div className="mt-10 mb-10 flex" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                            <button
                                onClick={handlePrevious}
                                disabled={currentPage === 1}
                                style={{
                                    padding: '8px 14px',
                                    backgroundColor: currentPage === 1 ? '#ccc' : '#6c757d',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                }}
                            >
                                Previous
                            </button>
                            <span style={{ fontWeight: '500' }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={handleNext}
                                disabled={currentPage === totalPages}
                                style={{
                                    padding: '8px 14px',
                                    backgroundColor: currentPage === totalPages ? '#ccc' : '#6c757d',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </>
                )}

                {/* Footer Buttons */}
                <div className='flex mt-6' style={{ justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        onClick={() => setShowCampaignModal(false)}
                        style={{
                            padding: '8px 14px',
                            backgroundColor: '#e0e0e0',
                            color: '#333',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            console.log("Placing call to:", mobileNumbers);
                        }}
                        disabled={mobileNumbers.length === 0}
                        style={{
                            padding: '8px 14px',
                            backgroundColor: 'var(--primary-400)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            opacity: mobileNumbers.length === 0 ? 0.6 : 1,
                        }}
                    >
                        Place Call
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CampaignModel;
